import { Box, Button, CircularProgress, Container, CssBaseline, Grid, Link, TextField, Typography } from '@mui/material'
import Copyright from 'components/Copyright'
import React, { useState } from 'react'
import { Navigate, Link as RouterLink } from 'react-router'
import { LoginActions, LoginStoreStates } from '.'
import { LoginContainer, LoginFormContainer } from './styles'

type OwnProps = {}
type LoginProps = OwnProps & LoginStoreStates & LoginActions

const Login = (props: LoginProps) => {
  const { auth } = props
  const { loggingIn, logInError, user } = auth

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  if (user) {
    return <Navigate replace to="/notifications" />
  }

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    props.logIn({ email, password })
  }

  return (
    <Container component="main">
      <CssBaseline />
      <LoginContainer>
        <img src="/images/logo.png" alt="logo" style={{ marginBottom: '16px' }} />

        <Typography component="h2" variant="h6" align="center">
          クチヨミとは、九州工業大学齊藤剛史研究室が提供する機械読唇技術に関するサービスです。
        </Typography>
        <Typography component="h2" variant="h6" align="center">
          利用規約に同意された場合のみ利用できます。
        </Typography>

        <Button variant="outlined" color="primary" sx={{ mt: 1 }}>
          <Link variant="subtitle1" component={RouterLink} to="/terms">
            利用規約
          </Link>
        </Button>

        <LoginFormContainer maxWidth="xs">
          {logInError && (
            <Typography color="error" variant="h6">
              {auth.logInError}
            </Typography>
          )}

          <form
            noValidate
            style={{
              width: '100%',
              marginTop: '8px',
            }}
            onSubmit={(e) => onSubmit(e)}>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              label="Email Address"
              type="email"
              autoComplete="email"
              autoFocus
              onChange={({ target }) => setEmail(target.value)}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              label="Password"
              type="password"
              autoComplete="current-password"
              onChange={({ target }) => setPassword(target.value)}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              disabled={loggingIn}
              sx={{ mt: 3, mb: 2 }}>
              {loggingIn ? <CircularProgress size={20} /> : 'ログイン'}
            </Button>
          </form>
          <Grid container>
            <Grid size="grow">
              <Link to="/password_reset" component={RouterLink}>
                パスワードをお忘れですか？
              </Link>
            </Grid>
            <Grid>
              <Link to="/signup" component={RouterLink}>
                アカウント作成
              </Link>
            </Grid>
          </Grid>
        </LoginFormContainer>
      </LoginContainer>
      <Box
        sx={{
          mt: 8,
        }}>
        <Copyright />
      </Box>
    </Container>
  )
}

export default Login
